import { notification } from "antd";
import { RcFile } from "antd/es/upload";
import i18next from "i18next";
import { preuploadFile, uploadFile, uploadFileState } from "@/apis/file";
import { Doc, DocTypeEnum } from "@/types/doc";
import { docAdd, docFetch } from "@/apis/doc";
import dayjs from "dayjs";
import getFileBuffer from "./getFileBuffer";

const MIME_MAP: Record<string, string> = {
  // 图片
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
  ico: 'image/x-icon',
  avif: 'image/avif',
  // 文档
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  csv: 'text/csv',
  md: 'text/markdown',
  html: 'text/html',
  xml: 'application/xml',
  // 压缩包
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  '7z': 'application/x-7z-compressed',
  tar: 'application/x-tar',
  gz: 'application/gzip',
  // 音视频
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  mp4: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
  avi: 'video/x-msvideo',
  // 数据 / 代码
  json: 'application/json',
  js: 'text/javascript',
  css: 'text/css',
  wasm: 'application/wasm',
  bin: 'application/octet-stream',
};

//根据一个doc递归复制所有叶子文件到一个新的doc
const extractLeafDocs = (docs: Doc[], result: Doc[] = []): Doc[] => {
  docs.forEach((doc) => {
    if (doc.nodeType === DocTypeEnum.LEAF) {
      result.push({ ...doc, subs: [] });
    }
    if (doc.subs?.length) extractLeafDocs(doc.subs, result);
  });
  return result;
};
export const copyDoc = async (docId: string) => {
  let newDoc: Doc | null = null;
  let doc = await docFetch(docId);
  if (doc) {
    newDoc = await docAdd({ name: dayjs().unix().toString(), nodeType: DocTypeEnum.NODE });
    let docNodes = extractLeafDocs([doc]);
    for (let f = 0; f < docNodes.length; f++) {
      let buffer = await getFileBuffer(docNodes[f].fileId);
      if (buffer) {
        let file = new File([buffer], docNodes[f].name, { type: MIME_MAP[docNodes[f].suffix] })
        let fileInfo = await upload({ name: docNodes[f].name, size: buffer.byteLength, file });
        if (fileInfo) {
          await docAdd({
            pId: newDoc.id,
            name: docNodes[f].name,
            nodeType: DocTypeEnum.LEAF,
            fileId: fileInfo.id,
            suffix: fileInfo.suffix
          });
        }
      }
    }
  }
  return newDoc;
};

//上传文件
export const upload = async (fileInfo: {
  name: string;
  size: number;
  file: Blob | RcFile | any;
}, wmsApi?: string) => {
  try {

    const { id: preId } = await preuploadFile({ name: fileInfo.name, size: fileInfo.size }, wmsApi)
    const formData = new FormData();
    formData.append('file', fileInfo.file);
    formData.append('partIndex', '1');
    formData.append('startPosition', '0');

    await uploadFile(preId, formData, wmsApi)
    let file = await uploadFileState(preId, wmsApi)
    return file
  } catch (e) {
    notification.error({ placement: 'top', message: i18next.t('layout.upFail'), description: i18next.t('layout.plTryAgain') })
  }
}